export interface GuardConfiguration {
  id?: number;
  currencyId: number;
  currencyName?: string;
  startDate: string;
  endDate: string;
  status: GuardConfigurationStatus | string;
  laborable: number;
  nonLaborable: number;
  especial: number;
  displayLabel?: string;
}

export enum GuardConfigurationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
